var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPixBrasil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 25",
    style: {
      enableBackground: "new 0 0 66 25"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#939599;stroke-width:0.3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#3EB6AA;}\n\t.st2{fill:#939599;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2356",
    className: "st0",
    d: "M27.1,22.4v-13c0-2.4,2-4.3,4.3-4.3h3.9c2.4,0,4.3,2,4.3,4.3v2.8c0,2.4-2,4.3-4.3,4.3h-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2360",
    className: "st0",
    d: "M40.7,5h1.7c1,0,1.8,0.8,1.8,1.8v9.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2364",
    className: "st1",
    d: "M43.8,3.5L43,2.7c-0.2-0.2-0.2-0.5,0-0.7l0.8-0.8c0.2-0.2,0.5-0.2,0.7,0L45.3,2 c0.2,0.2,0.2,0.5,0,0.7l-0.8,0.8C44.3,3.7,44,3.7,43.8,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2368",
    className: "st0",
    d: "M47.3,5H49c0.8,0,1.7,0.3,2.3,1l3.9,3.9c0.5,0.5,1.3,0.5,1.8,0L60.9,6c0.6-0.6,1.4-1,2.3-1h1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2372",
    className: "st0",
    d: "M47.3,16.4H49c0.8,0,1.7-0.3,2.3-1l3.9-3.9c0.5-0.5,1.3-0.5,1.8,0l3.9,3.9c0.6,0.6,1.4,1,2.3,1 h1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2376",
    className: "st1",
    d: "M17.2,18.9c-0.8,0-1.6-0.3-2.2-0.9l-3.2-3.2c-0.2-0.2-0.6-0.2-0.8,0L7.8,18 c-0.6,0.6-1.4,0.9-2.2,0.9H5l4,4c1.3,1.3,3.3,1.3,4.5,0l4-4C17.6,18.9,17.2,18.9,17.2,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2380",
    className: "st1",
    d: "M5.6,7.7c0.8,0,1.6,0.3,2.2,0.9l3.2,3.2c0.2,0.2,0.6,0.2,0.8,0L15,8.6c0.6-0.6,1.4-0.9,2.2-0.9 h0.4l-4-4c-1.3-1.3-3.3-1.3-4.5,0l-4,4C5,7.7,5.6,7.7,5.6,7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2384",
    className: "st1",
    d: "M21,11l-2.4-2.4c0,0-0.1,0-0.2,0h-1.1c-0.6,0-1.1,0.2-1.5,0.6l-3.2,3.2 c-0.3,0.3-0.7,0.4-1.1,0.4s-0.8-0.2-1.1-0.4L7.1,9.2c-0.4-0.4-1-0.6-1.5-0.6H4.2c0,0-0.1,0-0.2,0L1.6,11c-1.3,1.3-1.3,3.3,0,4.5 L4.1,18c0,0,0.1,0,0.2,0h1.4c0.6,0,1.1-0.2,1.5-0.6l3.2-3.2c0.6-0.6,1.6-0.6,2.2,0l3.2,3.2c0.4,0.4,1,0.6,1.5,0.6h1.1 c0,0,0.1,0,0.2,0l2.4-2.4C22.2,14.3,22.2,12.3,21,11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2388",
    className: "st2",
    d: "M30.4,21.3c-0.2,0-0.4,0.1-0.6,0.1v0.8c0.1,0.1,0.3,0.1,0.5,0.1c0.4,0,0.6-0.1,0.6-0.5 C30.8,21.4,30.7,21.3,30.4,21.3 M29.7,22.8v-1.6h0.1v0.1c0.2-0.1,0.4-0.1,0.6-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.3,0.2,0.5 c0,0.2-0.1,0.4-0.3,0.5c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.3,0-0.5-0.1v0.4L29.7,22.8L29.7,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2392",
    className: "st2",
    d: "M32,21.2c-0.4,0-0.6,0.1-0.6,0.5c0,0.3,0.2,0.5,0.6,0.5c0.4,0,0.6-0.1,0.6-0.5 C32.6,21.4,32.4,21.2,32,21.2 M32.5,22.2c0,0-0.3,0.1-0.5,0.1c-0.2,0-0.4,0-0.5-0.1c-0.2-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.2-0.5 c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.2,0.3,0.2,0.5S32.7,22.1,32.5,22.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2396",
    className: "st2",
    d: "M34.4,22.3l-0.4-1l0,0l-0.4,1h-0.1l-0.5-1.1h0.2l0.4,1l0,0l0.4-1H34l0.4,1l0,0l0.4-1H35 l-0.5,1.1H34.4L34.4,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2400",
    className: "st2",
    d: "M35.9,21.2c-0.4,0-0.5,0.2-0.5,0.4h1C36.4,21.4,36.2,21.2,35.9,21.2 M35.8,22.3 c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.1,0.4-0.1s0.3,0,0.4,0.1 c0.2,0.1,0.2,0.3,0.2,0.5h-1.2c0,0.2,0.1,0.4,0.5,0.4c0.2,0,0.4,0,0.6-0.1v0.1C36.2,22.3,36,22.3,35.8,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2404",
    className: "st2",
    d: "M36.9,22.3v-1.1H37v0.1c0.3-0.1,0.4-0.1,0.6-0.1l0,0v0.1h0c-0.2,0-0.3,0-0.5,0.1v1 C37,22.3,36.9,22.3,36.9,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2408",
    className: "st2",
    d: "M38.4,21.2c-0.4,0-0.5,0.2-0.5,0.4h1C38.9,21.4,38.7,21.2,38.4,21.2 M38.4,22.3 c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.1,0.4-0.1s0.3,0,0.4,0.1 c0.2,0.1,0.2,0.3,0.2,0.5h-1.2c0,0.2,0.1,0.4,0.5,0.4c0.2,0,0.4,0,0.6-0.1v0.1C38.7,22.3,38.5,22.3,38.4,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2412",
    className: "st2",
    d: "M40.5,21.3c-0.1-0.1-0.3-0.1-0.5-0.1c-0.4,0-0.6,0.1-0.6,0.5c0,0.3,0.2,0.5,0.4,0.5 c0.2,0,0.4-0.1,0.6-0.1C40.5,22.1,40.5,21.3,40.5,21.3z M40.5,22.3L40.5,22.3c-0.2,0-0.4,0-0.6,0c-0.2,0-0.3,0-0.4-0.1 c-0.1-0.1-0.2-0.3-0.2-0.5s0.1-0.4,0.3-0.5c0.1-0.1,0.3-0.1,0.5-0.1s0.3,0,0.5,0.1v-0.5h0.1v1.6L40.5,22.3L40.5,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2416",
    className: "st2",
    d: "M42.6,21.3c-0.2,0-0.4,0.1-0.6,0.1v0.8c0.2,0.1,0.3,0.1,0.5,0.1c0.4,0,0.6-0.1,0.6-0.5 C43.1,21.4,42.9,21.3,42.6,21.3 M43,22.2c0,0-0.3,0.1-0.4,0.1c-0.2,0-0.3,0-0.5-0.1v0.1h-0.1v-1.6h0.1v0.6c0.2-0.1,0.4-0.1,0.6-0.1 c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.3,0.2,0.5C43.2,21.9,43.2,22.1,43,22.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2420",
    className: "st2",
    d: "M43.4,22.8v-0.1c0,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.4-0.2l0.1-0.1l-0.6-1.1h0.2l0.5,1l0,0l0.5-1 h0.2l-0.6,1.3c-0.1,0.2-0.2,0.3-0.5,0.3C43.5,22.8,43.5,22.8,43.4,22.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2424",
    className: "st2",
    d: "M46.5,21.7h-0.4v0.4h0.4c0.3,0,0.4,0,0.4-0.2C47,21.7,46.8,21.6,46.5,21.7 M46.5,21h-0.4v0.4 h0.4c0.3,0,0.4,0,0.4-0.2C46.9,21,46.7,21,46.5,21 M47.2,22.1c-0.2,0.1-0.4,0.1-0.7,0.1h-0.7v-1.6h0.7c0.3,0,0.5,0,0.7,0.1 c0.1,0.1,0.2,0.2,0.2,0.3c0,0.2-0.1,0.3-0.2,0.3l0,0c0.2,0.1,0.3,0.2,0.3,0.4C47.3,22,47.3,22.1,47.2,22.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2428",
    className: "st2",
    d: "M48.7,21.8c-0.1,0-0.3,0-0.4,0C48,21.8,48,21.9,48,22s0.1,0.2,0.2,0.2c0.2,0,0.3,0,0.5-0.1 L48.7,21.8L48.7,21.8z M48.8,22.3L48.8,22.3c-0.2,0-0.4,0-0.6,0c-0.1,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0l0,0c0-0.2-0.1-0.3-0.4-0.3c-0.1,0-0.3,0-0.4,0v-0.2 c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0,0.5,0.1c0.1,0.1,0.2,0.2,0.2,0.4v0.7L48.8,22.3L48.8,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2432",
    className: "st2",
    d: "M50.5,22.3v-0.6c0-0.2-0.1-0.3-0.3-0.3c-0.1,0-0.3,0-0.5,0.1v0.8h-0.3v-1.1h0.3v0.1 c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.7L50.5,22.3L50.5,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2436",
    className: "st2",
    d: "M51.7,22.4c-0.2,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5 c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.3,0,0.4,0v0.2c0,0-0.3,0-0.4,0c-0.3,0-0.4,0.1-0.4,0.4c0,0.2,0.1,0.3,0.4,0.3 c0.2,0,0.3,0,0.5-0.1v0.2C52.1,22.3,51.9,22.4,51.7,22.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2440",
    className: "st2",
    d: "M53.2,21.4c-0.3,0-0.4,0.1-0.4,0.4s0.1,0.4,0.4,0.4c0.3,0,0.4-0.1,0.4-0.3 C53.7,21.5,53.5,21.4,53.2,21.4 M53.8,22.2c-0.1,0.1-0.3,0.1-0.6,0.1c-0.2,0-0.4,0-0.6-0.1c-0.2-0.1-0.2-0.3-0.2-0.5 c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.1,0.6-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.2,0.3,0.2,0.5C54,22,54,22.1,53.8,22.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2444",
    className: "st2",
    d: "M55.9,22.4c-0.2,0-0.4,0-0.6-0.2c-0.2-0.2-0.2-0.4-0.2-0.7c0-0.2,0.1-0.5,0.3-0.7 c0.2-0.1,0.4-0.2,0.7-0.2c0.2,0,0.3,0,0.6,0V21c-0.2,0-0.4,0-0.5,0c-0.4,0-0.6,0.2-0.6,0.5s0.2,0.5,0.5,0.5c0.2,0,0.4-0.1,0.7-0.1 v0.3C56.4,22.3,56.1,22.4,55.9,22.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2448",
    className: "st2",
    d: "M57.6,21.3c-0.3,0-0.4,0.1-0.4,0.3h0.8C57.9,21.4,57.8,21.3,57.6,21.3 M57.5,22.3 c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.4,0,0.5,0.1 c0.2,0.1,0.2,0.3,0.2,0.6h-1.1c0,0.2,0.1,0.3,0.4,0.3c0.2,0,0.4,0,0.6-0.1v0.2C58,22.3,57.7,22.3,57.5,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2452",
    className: "st2",
    d: "M59.7,22.3v-0.6c0-0.2-0.1-0.3-0.3-0.3c-0.1,0-0.3,0-0.5,0.1v0.8h-0.3v-1.1h0.3v0.1 c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4v0.7L59.7,22.3L59.7,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2456",
    className: "st2",
    d: "M60.9,22.4c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.2-0.1-0.3v-0.4h-0.2v-0.2h0.2v-0.3h0.3v0.3 h0.4v0.2h-0.4v0.4c0,0,0,0.2,0,0.2c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2,0v0.2C61.3,22.4,61,22.4,60.9,22.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2460",
    className: "st2",
    d: "M61.5,22.3v-1.1h0.3v0.1c0.2-0.1,0.4-0.1,0.6-0.1c0,0,0,0,0.1,0v0.3c0,0-0.1,0-0.1,0 c-0.2,0-0.3,0-0.4,0.1v0.8H61.5L61.5,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2464",
    className: "st2",
    d: "M63.6,21.8c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0.1-0.3,0.2s0.1,0.2,0.2,0.2c0.2,0,0.3,0,0.5-0.1 L63.6,21.8L63.6,21.8z M63.7,22.3L63.7,22.3c-0.2,0-0.4,0-0.6,0c-0.1,0-0.3,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.3-0.1,0.4-0.1s0.3,0,0.4,0l0,0c0-0.2-0.1-0.3-0.4-0.3c-0.1,0-0.3,0-0.4,0v-0.2c0.2,0,0.3,0,0.5,0 c0.2,0,0.4,0,0.5,0.1c0.1,0.1,0.2,0.2,0.2,0.4v0.7L63.7,22.3L63.7,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2466",
    className: "st2",
    d: "M64.3,20.7h0.3v1.6h-0.3V20.7z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPixBrasil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PIX (Brasil).52317445b10209596a087ef42e92a0cb.svg";